import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AdminDepartmentRequest } from 'src/app/models/department.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-admin-department',
  templateUrl: './modal-admin-department.component.html',
  styleUrls: ['../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalAdminDepartmentComponent implements OnInit {
  @Input() isCreating: boolean = true;
  @Input() newDepartment: AdminDepartmentRequest = null;
  @Input() areas: [] = [];
  @Input() positions: any[] = [];
  positionSelected = null;
  loading = false;
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private toastService: ToastrService,
    private rrhh: HumanResourcesService
  ) {

  }

  selectPosition(positionSelected) {
    for (let i = 0; i < this.positions.length; i++) {
      const position = this.positions[i];
      if (position.id == positionSelected) {
        this.newDepartment.head = position;
        break;
      }
    }
  }

  ngOnInit(): void {

  }

  createOrEdit() {
    if (this.isCreating) {
      this.loading = true;
      this.rrhh.createDepartment(this.newDepartment).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Departamento creado exitosamente");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error((error.error.message)?error.error.message:'Error al crear el departamento, intenta más tarde');
        }
      })
    } else {
      this.loading = true;
      this.rrhh.updateDepartment(this.newDepartment.id,this.newDepartment).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Departamento editado exitosamente");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error((error.error.message)?error.error.message:'Error al editar el departamento, intenta más tarde');
        }
      })
    }
  }
}
